// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const Environment = {
  production: false,
  googleMapsApiKey: 'AIzaSyC8V_M3PMyrcxz6a0ScrJ0AcXQF-6jkw4c',
  mapboxApiUrl: 'https://api.mapbox.com/geocoding/v5/mapbox.places/',
  mapbox_Token: 'pk.eyJ1IjoicGFzc2lvbmRldiIsImEiOiJjandqem9xbmkwaDgxNGFxZ2VwcXlmaXlzIn0.LnISKimehOGVZtLucxbZng',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
